import { createFileRoute, Outlet } from "@tanstack/react-router";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar";
import { Separator } from "@/components/ui/separator";
import { AppSidebar } from "@/widgets/app-sidebar";
import { ReportLauncher } from "@/widgets/report";

export const Route = createFileRoute("/_content")({
  component: ContentLayout,
});

function ContentLayout() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="flex h-14 shrink-0 items-center gap-2 border-b px-4">
          <SidebarTrigger className="-ml-1" />
          <Separator orientation="vertical" className="mr-2 !h-4" />
        </header>
        <div className="flex-1 overflow-y-auto">
          <Outlet />
        </div>
        <ReportLauncher />
      </SidebarInset>
    </SidebarProvider>
  );
}
